<template>
  <div>
    <slot :days="days" :hours="hours" :minutes="minutes" :seconds="seconds">
      <div v-if="timeRemaining > 0" class="countdown flex flex-ac flex-jc">
        <div class="countdown-item">
          <div class="num">{{ days }}</div>
          <div class="label">Days</div>
        </div>
        <div class="countdown-item">
          <div class="num">{{ hours }}</div>
          <div class="label">hours</div>
        </div>
        <div class="countdown-item">
          <div class="num">{{ minutes }}</div>
          <div class="label">Min</div>
        </div>
        <div class="countdown-item">
          <div class="num">{{ seconds }}</div>
          <div class="label">Sec</div>
        </div>
      </div>
      <div v-else class="time">结束时间：{{ endTime }}</div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    endTime: {
      type: [Date, String, Number],
      required: true
    }
  },
  data() {
    return {
      timeRemaining: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null
    }
  },
  watch: {
    endTime() {
      this.startCountdown()
    }
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    startCountdown() {
      this.updateCountdown()
    },
    clearTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    updateCountdown() {
      const endTime = new Date(this.endTime.replace(/-/g, '/')).getTime()
      const now = Date.now()
      this.timeRemaining = endTime - now

      if (this.timeRemaining <= 0) {
        this.clearTimer()
        this.$emit('countdown-ended')
        return
      }

      this.days = Math.floor(this.timeRemaining / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((this.timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((this.timeRemaining % (1000 * 60)) / 1000)

      // 使用 setTimeout 递归调用 updateCountdown
      this.timer = setTimeout(this.updateCountdown, 1000)
    }
  }
}
</script>
<style lang="less" scoped>
.countdown-item {
  background: #494d60;
  border-radius: 4px;
  width: 70px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin: 0 4px;
  padding: 10px 0 10px;
  font-weight: bold;
  line-height: 16px;
  .label {
    font-weight: 100;
    font-size: 8px;
    color: #bbb9b9;
    line-height: 10px;
    margin-top: 4px;
  }
}
.time {
  line-height: 37px;
  text-align: center;
}
</style>
